import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import actions from './actions';

import { logintoSQLSuccessLoadCompany } from '../../containers/Page/signin_api';
import authActionContacts from '../../redux/contacts/actions';
import { handleError } from '../../errorHandler';


export function* handleCompanyLoginRequest(action) {
  const { token, profile } = action.payload;
  try {
    const resultCompany =
      yield call(logintoSQLSuccessLoadCompany, token, profile.company_obj);
    if (resultCompany.code === 200) {
      yield put({
        type: actions.ADD_COMPANY,
        companies: [resultCompany.company],
        selectedId: resultCompany.company.id,
      });

      yield put({
        type: actions.LOAD_COMPANY_SUCCESS,
        companyProfile: resultCompany.company,
        token,
      });
      //      action.resolve();
    }
  } catch (e) {
    handleError(`Catch Sage: ${e}`);
    yield put({ type: actions.LOAD_COMPANY_ERROR });
    //    action.reject();
  }
}

export function* loadCompany() {
  yield takeEvery(actions.LOAD_COMPANY, handleCompanyLoginRequest);
}

export function* loadCompanySuccess() {
  yield takeEvery(actions.LOAD_COMPANY_SUCCESS, function* (payload) {
    localStorage.setItem('company', payload.companyProfile);
    if (payload.companyProfile && payload.companyProfile.onboarding === 0) {
      yield put(push('/dashboard'));
    } else {
      yield put(push('/dashboard/welcome'));
    }
    const data = {
      token: payload.token,
      company_id: payload.companyProfile.id,
    };
    yield put({
      type: authActionContacts.LOAD_CONTACTS,
      payload: data,
    });
  });
}

export function* loadCompanyError() {
  yield takeEvery(actions.LOAD_COMPANY_ERROR, function* () {
    yield handleError('company login error');
  });
}
/* eslint-disable no-empty-function */
export function* addCompany() {
  yield takeEvery(actions.ADD_COMPANY, function* () { });
}

export function* editCompany() {
  yield takeEvery(actions.EDIT_COMPANY, function* () { });
}
/* eslint-enable */

export default function* rootSaga() {
  yield all([
    fork(addCompany),
    fork(editCompany),
    fork(loadCompany),
    fork(loadCompanySuccess),
    fork(loadCompanyError),
  ]);
}




// WEBPACK FOOTER //
// ./src/redux/company/saga.js